import { SET_CURRENT_ROUTE, SET_PREV_ROUTE } from './types';

export function setCurrentRoute(title: string, url: string) {
  return {
    type: SET_CURRENT_ROUTE,
    title,
    url,
  };
}

export function setPrevRoute(title: string, url: string) {
  return {
    type: SET_PREV_ROUTE,
    title,
    url,
  };
}
